// extracted by mini-css-extract-plugin
export default {"form":"Edificioinfo_form__AOJBb"};